(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const scope=root.querySelector('[name="contact[Delivery scope]"]'),address=root.querySelector('[data-address]'),port=root.querySelector('[name="contact[Port]"]'),postcode=root.querySelector('[name="contact[Postcode]"]');if(!scope||!address||!port||!postcode)return;function update(){const portOnly=scope.value==='Delivery to port only';address.hidden=portOnly;address.querySelectorAll('input').forEach(input=>{input.disabled=portOnly;input.required=scope.value==='Door delivery';const title=input===postcode?'Delivery postcode':'Delivery city';root.querySelector('label[for="'+input.id+'"]').textContent=title+(input.required?' *':' (if known)');});port.required=false;root.querySelector('label[for="'+port.id+'"]').textContent=portOnly?'Destination container port':'Nearest container port (if known)';root.querySelector('[data-port-help]').textContent='Select a port, or choose Please advise / not sure. For another port, add its name under Additional requirements.';}scope.addEventListener('change',update);update();}document.querySelectorAll('[data-container-quote]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-container-quote]').forEach(init));})();

(() => {
  const root = document.querySelector('[data-container-quote]');
  if (!root || window.Shopify?.designMode) return;
  const key = 'coi_container_quote_pending_v1';
  const measurementId = 'G-SGYHRWVRVJ';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const clear = () => {
    try { window.sessionStorage.removeItem(key); } catch {}
  };
  const form = root.querySelector('form');
  const success = root.querySelector('.cq-success');
  if (!success) {
    if (!root.querySelector('.cq-error')) clear();
    form?.addEventListener('submit', () => {
      if (!allowed() || !form.checkValidity()) {
        clear();
        return;
      }
      try { window.sessionStorage.setItem(key, String(Date.now())); } catch {}
    });
    return;
  }
  let sent = false;
  function record() {
    if (sent || !allowed()) return;
    if (typeof window.gtag !== 'function' || window['ga-disable-' + measurementId] !== false) return;
    let pending;
    try { pending = Number(window.sessionStorage.getItem(key)); } catch { return; }
    const age = Date.now() - pending;
    if (!pending || age < 0 || age > 30 * 60 * 1000) {
      clear();
      return;
    }
    clear();
    sent = true;
    window.gtag('event', 'container_quote_submitted', {
      send_to: measurementId,
      form_name: 'container_quote',
      lead_type: 'full_container',
      transport_type: 'beacon'
    });
  }
  document.addEventListener('visitorConsentCollected', record);
  record();
  let attempts = 0;
  const timer = window.setInterval(() => {
    record();
    if (sent || ++attempts >= 15) window.clearInterval(timer);
  }, 1000);
})();
